import { createAction, props } from '@ngrx/store';
import { RestApiError } from 'src/app/common-components/errors/models/error-message';
import { UserPasswordResetModel } from '../models/user-password-reset.model';

export const userPasswordResetSubmitted = createAction(
   '[User Password Reset] Submitted',
   props<{ userPasswordReset: UserPasswordResetModel }>()
);

export const userPasswordResetSuccess = createAction('[API] Password Reset  Success');

export const userPasswordResetFailure = createAction('[API] Password Reset Failure', props<RestApiError>());
